import { createContext, use } from "react";

export interface UnsavedReportContextType {
  onClose: () => void;
}

export const UnsavedReportContext = createContext<UnsavedReportContextType | undefined>(undefined);

export const useUnsavedReportContext = (): UnsavedReportContextType | undefined => use(UnsavedReportContext);
